import {Injectable} from '@angular/core';
import {Subject} from "rxjs";

@Injectable({
  providedIn: 'root'
})
export class UserProfileService {

  onBoardingQuestionData = new Subject()

  constructor() {
  }
}
